import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { IConfirmDialogConfig } from '@app/infrastructure/models/dialog';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { SaveCancelButtonConfig } from '@app/infrastructure/models/form/button';
import { UntypedFormControl, Validators } from '@angular/forms';
import { CritterService } from '@app/infrastructure/core/services/api/critter.service';
import { Critter } from '@app/infrastructure/models/critter';
import { CritterState } from '@app/infrastructure/core/services/state/critter.state';
import { UserStateService } from '@app/infrastructure/core/services/state/user-state.service';
import { StudentCoinService } from '@app/infrastructure/core/services/api/student-coin.service';
import { RequiredValidation } from '@app/infrastructure/utils/validation/required-validation';

@Component({
  templateUrl: './avatar-selection-dialog.component.html',
  styleUrls: ['./avatar-selection-dialog.component.scss'],
})
export class AvatarSelectionDialogComponent implements OnInit {
  buttonConfig: SaveCancelButtonConfig = new SaveCancelButtonConfig({
    save: 'Yes, update now!',
    cancel: 'Cancel',
    hasCustomCancel: true,
  });
  public selectedCritter: UntypedFormControl = new UntypedFormControl(
    null,
    Validators.required,
  );
  public critters: Critter[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialog: IConfirmDialogConfig,
    private dialogRef: MatDialogRef<ConfirmDialogComponent>,
    private critterState: CritterState,
    private userState: UserStateService,
    private coinService: StudentCoinService,
  ) {}

  ngOnInit(): void {
    this.critters = this.critterState.critters;
  }

  public get enoughCoins(): boolean {
    return this.coinService.coinPurse >= 5;
  }

  public get submitDisabled(): boolean {
    return !this.enoughCoins || !this.isValid();
  }

  public disableOption(critter: Critter): boolean {
    if (this.userState.userAvatar?.id === critter.id) {
      return true;
    }
    return null;
  }

  public isValid(): boolean {
    return this.selectedCritter.valid;
  }

  public submit(): void {
    const critter = this.critterState.getCritterById(
      this.selectedCritter.value,
    );
    this.userState.setUserAvatar(critter);

    this.dialogRef.close(this.selectedCritter.value);
  }
}
